// Mirrors the existing mutation route. Backend authorization remains authoritative.
export const canCreateProduct = (user) => {
  if (!user || !Number.isSafeInteger(Number(user.clientId)) || Number(user.clientId) <= 0) return false
  const values = (items, fields) => (Array.isArray(items) ? items : []).flatMap((item) =>
    typeof item === 'string' ? [item] : fields.map((field) => item?.[field])
  ).filter((item) => typeof item === 'string').map((item) => item.trim().toLowerCase())
  const roles = values(user.roles, ['type', 'name_role', 'name'])
  const privileges = values(user.privileges, ['key', 'name_privilege', 'name'])
  return user.isGlobalAdmin === true || roles.some((role) => ['globaladmin', 'clientadmin'].includes(role)) || privileges.includes('all')
}

// PUT permits global administrators across tenants; other mutation actors stay
// within the session tenant. Only pass a product returned by the detail GET.
export const canEditProduct = (user, product) => {
  const validId = (value) => ['string', 'number'].includes(typeof value) &&
    /^[1-9]\d*$/.test(String(value)) && Number(value) <= 2147483647
  if (!user || !validId(product?.id) || !validId(product?.client_id)) return false
  const values = (items, fields = []) => (Array.isArray(items) ? items : [items])
    .flatMap((item) => typeof item === 'string' ? [item] : fields.map((field) => item?.[field]))
    .filter((item) => typeof item === 'string').map((item) => item.trim().toLowerCase())
  const roles = [...values(user.roles, ['type', 'name_role', 'name']), ...values(user.roleTypes), ...values(user.role), ...values(user.roleType)]
  // The controller's cross-tenant exception is narrower than route RBAC.
  const globalScope = user.isGlobalAdmin === true || (Array.isArray(user.roles) ? user.roles : [])
    .some((role) => typeof role === 'string' ? role === 'globalAdmin' : role?.type === 'globalAdmin' || role?.name_role === 'globalAdmin')
  if (globalScope) return true
  const privileges = [...values(user.privileges, ['key', 'name_privilege', 'name']), ...values(user.privilegeKeys)]
  return validId(user.clientId) && Number(user.clientId) === Number(product.client_id) &&
    (roles.includes('globaladmin') || roles.includes('clientadmin') || privileges.includes('all'))
}
